module.exports = __webpack_public_path__ + "img/click-me.37d4d666.png";